import React from 'react';
import { Box } from '@mui/material';

const BrandLogo = ({ compact = false, height = 46, sx = {}, ...props }) => (
  <Box
    component="img"
    src={compact ? '/aztires-mark.svg' : '/aztires-logo.svg'}
    alt="AzTires"
    sx={{
      display: 'block',
      width: compact ? height : 'auto',
      height,
      flexShrink: 0,
      ...sx,
    }}
    {...props}
  />
);

export default BrandLogo;
